import React, { createContext, useState } from 'react';

export const ZONE_FR = 'FR';
export const ZONE_INT = 'INT';

const defaultZone = localStorage.getItem('zoneId') || ZONE_FR;

localStorage.setItem('zoneId', defaultZone);

export const ZoneContext = createContext({
  zone: defaultZone,
  changeZone: () => {},
});

export const ZoneProvider = ({ children }) => {
  const [zone, setZone] = useState(defaultZone);

  const changeZone = (newZone) => {
    localStorage.setItem('zoneId', newZone);
    setZone(newZone);
  };

  return <ZoneContext.Provider value={{ zone, changeZone }}>{children}</ZoneContext.Provider>;
};
